<button
  type="button"
  id="ai-chatbot-mode-toggle"
  class="mode-toggle"
  [matMenuTriggerFor]="modeMenu"
  aria-label="Choose generation speed and cost"
  aria-haspopup="menu"
>
  <mat-icon
    class="mode-toggle-icon"
    svgIcon="mode-settings"
    aria-hidden="true"
  ></mat-icon>
  <span class="mode-toggle-label">
    {{ aiChatbotService.selectedMode() === 'fast' ? 'Express' : 'Quality' }}
  </span>
  <mat-icon
    class="mode-toggle-chevron"
    svgIcon="chevron-down"
    aria-hidden="true"
  ></mat-icon>
</button>

<mat-menu
  #modeMenu="matMenu"
  [overlapTrigger]="false"
  xPosition="before"
  yPosition="above"
  aria-label="Speed and cost"
  panelClass="mode-toggle-menu-panel"
>
  <div class="mode-toggle-menu-panel">
    <h4 class="mode-toggle-menu-title">Speed & Cost</h4>

    <button
      type="button"
      mat-menu-item
      class="mode-toggle-menu-item"
      [class.mode-toggle-menu-item-selected]="
        aiChatbotService.selectedMode() === 'quality'
      "
      (click)="setMode('quality')"
    >
      <mat-icon
        class="mode-toggle-menu-item-icon"
        svgIcon="mode-settings"
        aria-hidden="true"
      ></mat-icon>
      <span class="mode-toggle-menu-item-body">
        <span class="mode-toggle-menu-item-title">Quality</span>
        <span class="mode-toggle-menu-item-description">
          Better quality and reasoning for complex layouts. Uses more credits.
        </span>
      </span>
      @if (aiChatbotService.selectedMode() === 'quality') {
        <mat-icon
          class="mode-toggle-menu-item-check"
          svgIcon="mode-check"
          aria-hidden="true"
        ></mat-icon>
      }
    </button>

    <button
      type="button"
      mat-menu-item
      class="mode-toggle-menu-item"
      [class.mode-toggle-menu-item-selected]="
        aiChatbotService.selectedMode() === 'fast'
      "
      (click)="setMode('fast')"
    >
      <mat-icon
        class="mode-toggle-menu-item-icon"
        svgIcon="mode-lightning"
        aria-hidden="true"
      ></mat-icon>
      <span class="mode-toggle-menu-item-body">
        <span class="mode-toggle-menu-item-title">Express</span>
        <span class="mode-toggle-menu-item-description">
          Quick iterations for less credits.
        </span>
      </span>
      @if (aiChatbotService.selectedMode() === 'fast') {
        <mat-icon
          class="mode-toggle-menu-item-check"
          svgIcon="mode-check"
          aria-hidden="true"
        ></mat-icon>
      }
    </button>
  </div>
</mat-menu>
